import React, { useState } from "react";

import "./styles/index.css";

import { ERRORS, LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import { NOTIFY } from "common/config";

import { CUSTOMER_APIs } from "apihandlers/customer";

import TxtBox from "components/Custom/TxtBox";
import AutoComplete from "components/Custom/AutoComplete";
import Btn from "components/Custom/Btn";
import SkeletonBox from "components/Custom/SkeletonBox";

const AddShops = (props) => {
  const {
    customerRef,
    cityRef,
    center,
    screenshotUrl,
    customerType,
    setIsScreenshotVisible,
    getShopDetails,
    cities,
    fileId,
  } = props;

  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const manageShopDetails = () => {
    const leadName = (
      document.getElementById("shopName") as HTMLInputElement
    ).value.trim();
    const customerTypeId = customerRef.current.selectedValue.id;
    const cityId = cityRef.current.selectedValue.id;
    const inchargeId = (
      document.getElementById("incharge") as HTMLInputElement
    ).value.trim();
    const address = (
      document.getElementById("address") as HTMLInputElement
    ).value.trim();
    const latitude = center.lat;
    const longitude = center.lng;
    const mobileNumber = (
      document.getElementById("mobile") as HTMLInputElement
    ).value.trim();

    let errors = [];
    if (leadName === "") {
      errors.push({
        id: "selectBtnValue",
        msg:
          "<span class='bold'>" +
          LABELS.NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: -1,
      leadName,
      cityId,
      address,
      latitude: Number(latitude),
      longitude: Number(longitude),
      inchargeId,
      customerTypeId,
      mobileNumber,
      photoId: fileId,
    };
    console.log("args: ", args);

    // return;
    CUSTOMER_APIs.manageScavenging(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
    setIsScreenshotVisible(false);
  };

  return (
    <div className="formGroup" style={{ width: "70%", paddingTop: "20px" }}>
      <div className="formGroup required ">
        <label>
          {LABELS.NAME}
          <span>*</span>
        </label>
        <TxtBox id="shopName" type={"text"}></TxtBox>
      </div>

      <div className="formGroup  ">
        <label>{LABELS.INCHARGE}</label>
        <TxtBox id="incharge" type={"text"}></TxtBox>
      </div>
      <div className="formGroup" style={{ paddingBottom: "15px" }}>
        <label>{LABELS.ADDRESS}</label>
        <TxtBox type={"text"} id="address"></TxtBox>
      </div>
      <div className=" flexRowJustify ">
        <div className="formGroup width45">
          <label>{LABELS.MOBILE_NUMBER}</label>
          <TxtBox id="mobile" type={"number"}></TxtBox>
        </div>
        <div className="formGroup  width45">
          <label>{LABELS.CATEGORY}</label>
          <AutoComplete list={customerType} childRef={customerRef} />
        </div>
      </div>
      <div className=" flexRowJustify">
        <div className="formGroup  width45">
          <label>{LABELS.CITY}</label>
          <AutoComplete list={cities} childRef={cityRef} />
        </div>
      </div>

      <div className=" flexRowJustify">
        <div className="formGroup  width45">
          <label>{LABELS.LATITUDE}</label>
          <TxtBox
            id="latitude"
            type={"number"}
            text={center.lat}
            disabled
          ></TxtBox>
        </div>
        <div className="formGroup  width45">
          <label>{LABELS.LONGITUDE}</label>
          <TxtBox
            id="longitude"
            type={"number"}
            text={center.lng}
            disabled
          ></TxtBox>
        </div>
      </div>
      <div className=" flexRowJustify">
        <div className="formGroup width30 "></div>
        <div className="formGroup  ">
          <Btn text={LABELS.REFRESH_CO_ORDINATES} onClick={getShopDetails} />
        </div>
        <div className="formGroup width30"></div>
      </div>
      {/* url link  */}
      {/* <div className="formGroup" style={{ paddingBottom: "15px" }}>
              <label>{LABELS.URL}</label>
              <TxtRow id="url" type="url" defaultValue={url}></TxtRow>
            </div> */}

      <div className="formGroup screentShotImg width100">
        {fileId ? (
          <img
            id={"scavengingImg"}
            src={screenshotUrl}
            alt="Screenshot"
            className="width100"
          />
        ) : (
          <SkeletonBox className="width100" height={300} />
        )}
      </div>
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className=" flexRowJustify">
        <div className="formGroup width30"></div>
        <div className="formGroup" style={{ paddingTop: "10px" }}>
          <Btn text={LABELS.SAVE} onClick={manageShopDetails} />
        </div>
        <div className="formGroup width30"></div>
      </div>
    </div>
  );
};

export default AddShops;
